import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StockDataSourceService } from 'src/app/core/data-sources/stock-data-source.service';
import { toExcelFormat } from 'src/app/helpers/format-position';
import { findCrateLevel } from 'src/app/helpers/find-crate-level';
import * as moment from 'moment';
import { UserRoles } from 'src/models/User';
import { ActivatedRoute } from '@angular/router';
import { ActionsEnum } from 'src/app/core/data-sources/action-data-source.service';
import { ActionPermissionsService } from 'src/app/core/services/action-permissions.service';
import { OutOrderStateEnum } from 'src/models/OutOrder';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-out-order-details-modal',
  templateUrl: './out-order-details-modal.component.html',
  styleUrls: ['./out-order-details-modal.component.scss']
})
export class OutOrderDetailsModalComponent implements OnInit {
  level;
  userRole: UserRoles = null;
  stateEnum = OutOrderStateEnum;
  actionsEnum = ActionsEnum;
  constructor(
    public dialogRef: MatDialogRef<OutOrderDetailsModalComponent>,
    private stockService: StockDataSourceService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    private actionPermissionsService: ActionPermissionsService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.userRole = this.route.firstChild.snapshot.data.role;
    this.mapCratesSku();
  }

  mapCratesSku() {
    if (this.data?.executionPlan?.selectedPallets?.length === 0) {
      return;
    }
    this.data.crates.forEach(async crate => {
      crate.details = await this.stockService.getStockDetails(crate.tagRfid);
      if (crate.details) this.level = findCrateLevel(crate.z, crate.details.levels);
      this.data.executionPlan.selectedPallets.forEach(pallet => {
        if (crate.id === pallet.palletId) {
          crate.sku = pallet.sku;
        }
      });
      if (crate.details.crate.skuGroups.length) {
        crate.pickingProductsSku = [];
        crate.details.crate.skuGroups.forEach(pallet => {
          if (crate.id === pallet.crateId) {
            crate.pickingProductsSku.push(pallet.sku);
          }
        });
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  timestampToDate(timestamp) {
    return moment(timestamp).format('DD/MM/YYYY - HH:mm');
  }

  setExcelFormat(x, y) {
    return toExcelFormat(x, y);
  }

  canPerformAction(action: ActionsEnum) {
    return this.actionPermissionsService.hasPermission(action, this.userRole);
  }

  removeOrder() {
    const confirmModalDialogRef = this.dialog.open(ConfirmModalComponent, {
      panelClass: 'confirm-modal',
      autoFocus: false,
      data: {
        label: `Você tem certeza que deseja remover a ordem ${this.data?.no}?`,
        confirmBtnClass: 'alert'
      }
    });

    confirmModalDialogRef.afterClosed().subscribe(async (res) => {
      if (res === "SUBMITTED") {
        this.dialogRef.close({ removeOrder: true, orderId: this.data.id });
      }
    });
  }

}
